export interface ScanRequest {
  name: string;
  street: string;
  zip: string;
  country: string;
}

export enum ScanValidationStatus {
  MISSING = 'MISSING',
  MATCH = 'MATCH',
  OTHER = 'OTHER',
  PRESENT = 'PRESENT',
}

export interface SingleResultResponse {
  status: string;
  response: IDirectoryResult;
}

export interface IDirectoryResult {
  syncStatus: string;
  street: string;
  streetAndNo: string;
  streetNoStatus: string;
  streetStatus: string;
  zip: string;
  zipStatus: string;
  nameStatus: string;
  name: string;
  directoryType: ScanDirectoriesEnum;
  directoryName?: string;
  website: string;
  websiteStatus: string;
  openingHours: string;
  openingHoursStatus: string;
  photosStatus: string;
  phone: string;
  phoneStatus: string;
  city: string;
  cityStatus: string;
  fetching: boolean;
}

export interface ScanCreationResponse {
  status: string;
  response: {
    searchData: ISearchData;
  };
}
export interface ISearchData {
  id: number;
  dateCreated: Date;
  token: string;
  name: string;
  street: string;
  streetNo: string;
  zip: string;
  city: string;
  country: string;
  province: string;
  shortUrl: string;
  streetAndNo: string;
}

export enum SingleResultQueryParam {
  TOKEN = 'token',
  SEARCH_ID = 'searchId',
  DIRECTORY = 'directory',
}

export enum GenericScanParameters {
  JOB_ID = 'jobid',
  CHANNELS = 'channels',
  FORM_ENABLED = 'form',
  ESTABLISHMENT_ID = 'establishmentId',
}

export interface ScanQueryParams {
  validations: string[];
  value: ScanRequest;
}

export enum ScanQueryParametersEnum {
  NAME = 'name',
  STREET = 'street',
  ZIP = 'zip',
  COUNTRY = 'country',
}

export enum ScanTypeEnum {
  QUERY_PARAM_SCAN_WITH_FORM = 'QUERY_PARAM_SCAN_WITH_FORM',
  JOB_ID_SCAN = 'JOB_ID_SCAN',
  QUERY_PARAM_SCAN = 'QUERY_PARAM_SCAN',
  DEFAULT_SCAN = 'DEFAULT',
}

export const mandatoryYextComparasionOrder: string[] = [
  'FACEBOOK',
  'YELP',
  'FOURSQUARE',
  'GOLOCAL',
  'GOYELLOW',
  'CYLEX',
  'DIALO',
  'MEINESTADT',
  'WHERETO',
  'KOOMIO',
  'BUNDESTELEFONBUCH',
];

export interface ScanCountry {
  countryCode: string;
  name: string;
}

export enum ScanDirectoriesEnum {
  APPLE_MAPS = 'APPLE_MAPS',
  BAIDU = 'BAIDU',
  GOOGLE = 'GOOGLE',
  GOOGLE_MAPS = 'GOOGLE_MAPS',
  FOURSQUARE = 'FOURSQUARE',
  FACEBOOK = 'FACEBOOK',
  YELP = 'YELP_API',
  BING = 'BING',
  GELBE_SEITEN = 'GELBE_SEITEN',
  MEINESTADT = 'MEINESTADT',
  GO_LOCAL = 'GO_LOCAL',
  BUSINESSBRANCHENBUSH = 'BUSINESSBRANCHENBUCH',
  CYLEX = 'CYLEX',
  STADTBRANCHENBUCH = 'STADTBRANCHENBUCH',
  I_GLOBAL = 'I_GLOBAL',
  OEFFNUNGSZEITENBUCH = 'OEFFNUNGSZEITENBUCH',
  BUNDES_TELEFONBUCH = 'BUNDES_TELEFONBUCH',
  UNTERNEHMENSAUSKUNFT = 'UNTERNEHMENSAUSKUNFT',
  WO_GIBTS_WAS = 'WO_GIBTS_WAS',
  TUPALO = 'TUPALO',
  DIALO = 'DIALO',
  BROWNBOOK = 'BROWNBOOK',
  HOTFROG = 'HOTFROG',
  KOOMIO = 'KOOMIO',
  BRANCHENBUCH_DEUTSCHLAND = 'BRANCHENBUCH_DEUTSCHLAND',
  INFOBEL = 'INFOBEL',
  INFO_IS_INFO = 'INFO_IS_INFO',
  YALWA = 'YALWA',
  GO_YELLOW = 'GO_YELLOW',
  MARKTPLATZ_MITTELSTAND = 'MARKTPLATZ_MITTELSTAND',
  FREIEAUSKUNFT = 'FREIEAUSKUNFT',
  WHERE_TO = 'WHERE_TO',
  FIND_OPEN = 'FIND_OPEN',
  LOKALEAUSKUNFT = 'LOKALEAUSKUNFT',
  GUIDELOCAL = 'GUIDELOCAL',
  YELLBO = 'YELLBO',
  ABCLOCAL = 'ABCLOCAL',
  NAVMII = 'NAVMII',
  JELLOO = 'JELLOO',
  HOLIDAY_CHECK = 'HOLIDAY_CHECK',
  INSTAGRAM = 'INSTAGRAM',
  NOKIA_HERE = 'NOKIA_HERE',
  TRIP_ADVISOR = 'TRIP_ADVISOR',
  UBER = 'UBER',
  WAZE = 'WAZE',
  YANDEX = 'YANDEX',
}

export interface IScanDirectory {
  id: ScanDirectoriesEnum;
  name: string;
}

export const ScanDirectories: IScanDirectory[] = [
  { id: ScanDirectoriesEnum.GOOGLE, name: 'Google' },
  { id: ScanDirectoriesEnum.GOOGLE_MAPS, name: 'Google Maps' },
  { id: ScanDirectoriesEnum.FOURSQUARE, name: 'Foursquare' },
  { id: ScanDirectoriesEnum.FACEBOOK, name: 'Facebook' },
  { id: ScanDirectoriesEnum.YELP, name: 'Yelp' },
  { id: ScanDirectoriesEnum.BING, name: 'Bing' },
  { id: ScanDirectoriesEnum.APPLE_MAPS, name: 'Apple Maps' },
  { id: ScanDirectoriesEnum.INSTAGRAM, name: 'Instagram' },
  { id: ScanDirectoriesEnum.TRIP_ADVISOR, name: 'Trip Advisor' },
  { id: ScanDirectoriesEnum.BAIDU, name: 'Baidu' },
  { id: ScanDirectoriesEnum.CYLEX, name: 'Cylex' },
  { id: ScanDirectoriesEnum.I_GLOBAL, name: 'I Global' },
  { id: ScanDirectoriesEnum.TUPALO, name: 'Tupalo' },
  { id: ScanDirectoriesEnum.BROWNBOOK, name: 'Brownbook' },
  { id: ScanDirectoriesEnum.HOTFROG, name: 'Hotfrog' },
  { id: ScanDirectoriesEnum.INFOBEL, name: 'Infobel' },
  { id: ScanDirectoriesEnum.INFO_IS_INFO, name: 'InfoIsInfo' },
  { id: ScanDirectoriesEnum.WHERE_TO, name: 'Where To?' },
  { id: ScanDirectoriesEnum.FIND_OPEN, name: 'Find Open' },
  { id: ScanDirectoriesEnum.STADTBRANCHENBUCH, name: 'Opendi' },
  { id: ScanDirectoriesEnum.NAVMII, name: 'Navmii' },
  { id: ScanDirectoriesEnum.HOLIDAY_CHECK, name: 'Holiday Check' },
  { id: ScanDirectoriesEnum.NOKIA_HERE, name: 'Nokia Here' },
  { id: ScanDirectoriesEnum.WAZE, name: 'Waze' },
  { id: ScanDirectoriesEnum.UBER, name: 'Uber' },
  { id: ScanDirectoriesEnum.YANDEX, name: 'Yandex' },
];

export const scanCountries: ScanCountry[] = [
  { countryCode: 'AT', name: 'Austria' },
  { countryCode: 'BE', name: 'Belgium' },
  { countryCode: 'CN', name: 'China' },
  { countryCode: 'HR', name: 'Croatia' },
  { countryCode: 'CZ', name: 'Czech Republic' },
  { countryCode: 'FR', name: 'France' },
  { countryCode: 'DE', name: 'Germany' },
  { countryCode: 'HU', name: 'Hungary' },
  { countryCode: 'IT', name: 'Italy' },
  { countryCode: 'JP', name: 'Japan' },
  { countryCode: 'LU', name: 'Luxembourg' },
  { countryCode: 'NL', name: 'Finland' },
  { countryCode: 'PL', name: 'Poland' },
  { countryCode: 'PT', name: 'Portugal' },
  { countryCode: 'ES', name: 'Spain' },
  { countryCode: 'TR', name: 'Tunisia' },
  { countryCode: 'UA', name: 'Ukraine' },
  { countryCode: 'UK', name: 'United Kingdom' },
];

export const LessThanOne = '<1%';
